$(function(){

////////////////////////////////////
///スライダー
////////////////////////////////////

	$('.firstview__block').slick({
		dots: true,				//ページャーの有無
		arrows: true,			//矢印の有無
		prevArrow:'<div class="slick-arrow-prev"></div>',
		nextArrow:'<div class="slick-arrow-next"></div>',
		slidesToShow: 1,
		autoplay: true,			//自動：true / 手動：false
		speed: 500,			//スピード
		autoplaySpeed: 4000,	//スライドの速度
		pauseOnHover: false		//オンマウスで一時停止させるかどうか
	});


////////////////////////////////////
///ブレークポイント769pxで画像の切り替え
////////////////////////////////////

	var $setElem = $('.imgchange'),
	pcName = '_pc',
	spName = '_sp',
	replaceWidth = 769;
	$setElem.each(function(){
		var $this = $(this);
		var windowWidth = window.innerWidth ? window.innerWidth: $(window).width();
		function imgSize(){
			var windowWidth = window.innerWidth ? window.innerWidth: $(window).width();
			if(windowWidth >= replaceWidth) {
				$this.attr('src',$this.attr('src').replace(spName,pcName)).css({visibility:'visible'});
			} else if(windowWidth < replaceWidth) {
				$this.attr('src',$this.attr('src').replace(pcName,spName)).css({visibility:'visible'});
			}
		}
		$(window).resize(function(){
			imgSize();
		});
		imgSize();
	});

});
